import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import {AuthComponent} from './theme/layout/auth/auth.component';
import { DeleteAccountComponent } from './pages/authentication/delete-account/delete-account.component';

const routes: Routes = [
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    children: [
      {
        path: 'privacy-policy',
        redirectTo: 'privacy-policy',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: 'delete-account',
    component: DeleteAccountComponent,
    children: [
      {
        path: 'delete-account',
        redirectTo: 'delete-account',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: 'auth/signin',
        pathMatch: 'full'
      },
      {
        path: 'auth',
        loadChildren: () => import('./pages/authentication/authentication.module').then(module => module.AuthenticationModule)
      }
    ]
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(module => module.DashboardModule)
      },
      {
        path: 'user',
        loadChildren: () => import('./pages/user/userPage.module').then(module => module.UiBasicModule)
      },
      {
        path: 'allParams',
        loadChildren: () => import('./pages/params/paramsPage.module').then(module => module.TblBootstrapModule)
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
